import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http/http';
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as fromAuth from '../../store';
import { Store } from '@ngrx/store';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private storeAuth: Store<fromAuth.AuthState>
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        // TODO: Pendiente por parte de @Jefferson debe revisar el backend y ver por que en algunos casos el status esta devolviendo "0"
        if (err.status === 401 || err.status === 0) {
          this.storeAuth.dispatch(fromAuth.logout());
          this.auth.cleanSession();
        }
        return throwError(err);
      })
    );
  }
}
